import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DropdownToggleDirective } from './directives/dropdown-toggle.directive'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomToastrComponent } from './components/custom-toastr/custom-toastr.component'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { SideNavComponent } from './components/side-nav/side-nav.component'
import { HeaderComponent } from './components/header/header.component'
import { LoaderComponent } from './components/loader/loader.component'
import { TableComponent } from './components/table/table.component'
import { FiltersComponent } from './components/filters/filters.component'
import { MatSidenavModule } from '@angular/material/sidenav'
import { SelectModule } from 'primeng/select'
import { MultiSelectModule } from 'primeng/multiselect'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatNativeDateModule } from '@angular/material/core'
import { MatMenuModule } from '@angular/material/menu'
import { ActionsMenuComponent } from './components/actions-menu/actions-menu.component'
import { MatDialogModule } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { UploadFileComponent } from './components/upload-file/upload-file.component'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { MatBadgeModule } from '@angular/material/badge'
import { MatStepperModule } from '@angular/material/stepper'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { RiskDateIconComponent } from './components/icons/risk-date-icon/risk-date-icon.component'
import { RiskBagIconComponent } from './components/icons/risk-bag-icon/risk-bag-icon.component'
import { RiskScoreIconComponent } from './components/icons/risk-score-icon/risk-score-icon.component'
import { OpenTreatmentIconComponent } from './components/icons/open-treatment-icon/open-treatment-icon.component'
import { OverdueTreatmentIconComponent } from './components/icons/overdue-treatment-icon/overdue-treatment-icon.component'
import { PdfIconComponent } from './components/icons/pdf-icon/pdf-icon.component'
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component'
import { TranslatePipe } from '@ngx-translate/core'
import { AttachmentsComponent } from './components/attachments/attachments.component'
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component'
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component'
import { FrequencySchedulingComponent } from './components/frequency-scheduling/frequency-scheduling.component'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { TreeTableModule } from 'primeng/treetable'
import { SafeHtmlPipe } from './pipes/safe-html.pipe'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { TreeModule } from 'primeng/tree'
import { TreeDragDropService } from 'primeng/api'
import { AuditingComponent } from './components/auditing/auditing.component'
import { CarouselModule } from 'primeng/carousel'
import { CustomSelectComponent } from './components/custom-select/custom-select.component'
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component'
import { DatePickerComponent } from './components/date-picker/date-picker.component'
import { ListComponent } from './components/list/list.component'
import { TableModule } from 'primeng/table'
import { PaginationComponent } from './components/pagination/pagination.component'
import { NoResultFoundComponent } from './components/no-result-found/no-result-found.component'
import { MobileSidenavComponent } from './components/mobile-sidenav/mobile-sidenav.component'
import { BreadcrumbModule } from 'primeng/breadcrumb'
import { TooltipModule } from 'primeng/tooltip'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { BreadCrumb } from './components/bread-crumb/bread-crumb'
import { DocumentViewDetails } from './components/document-view-details/document-view-details'
import { StagesHistory } from './components/stages-history/stages-history'
import { LocalizedDatePipe } from './pipes/localized-date.pipe'
import { ShowHideColumnDialogComponent } from './components/show-hide-column-dialog/show-hide-column-dialog.component'
import { EditorModule } from 'primeng/editor'
import { BilingualSyncDirective } from './pipes/sync-names.directive'
import { HtmlToTextPipe } from './pipes/html-to-text.pipe'

// Get the language from localStorage
export function getLocaleFromLocalStorage(): string {
  const lang = localStorage.getItem('lang')
  return lang ? lang : 'en'
}
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      // toastComponent: CustomToastrComponent
      positionClass:
        getLocaleFromLocalStorage() === 'en'
          ? 'toast-bottom-right'
          : 'toast-bottom-left',
      preventDuplicates: true,
      progressBar: true
    }),
    MatSidenavModule,
    SelectModule,
    MultiSelectModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatMenuModule,
    MatDialogModule,
    MatExpansionModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    TranslatePipe,
    MatInputModule,
    MatSelectModule,
    TreeTableModule,
    SafeHtmlPipe,
    LocalizedDatePipe,
    DragDropModule,
    TreeModule,
    CarouselModule,
    TableModule,
    BreadcrumbModule,
    BreadCrumb,
    DocumentViewDetails,
    TooltipModule,
    AutoCompleteModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    StagesHistory,
    MatBadgeModule,
    EditorModule,
    HtmlToTextPipe,
    ActionsMenuComponent,
    AttachmentsComponent,
    ConfirmDialogComponent,
    AlertDialogComponent,
    LoaderComponent,
    NoResultFoundComponent,
    CustomToastrComponent,
    PaginationComponent,
    DeleteModalComponent,
    CustomSelectComponent,
    DatePickerComponent,
    DateRangePickerComponent,
    UploadFileComponent,
    HeaderComponent,
    SideNavComponent,
    MobileSidenavComponent,
    FiltersComponent,
    AuditingComponent,
    FrequencySchedulingComponent,
    ShowHideColumnDialogComponent,
    TableComponent,
    RiskDateIconComponent,
    RiskBagIconComponent,
    RiskScoreIconComponent,
    OpenTreatmentIconComponent,
    OverdueTreatmentIconComponent,
    PdfIconComponent,
    ListComponent,
    BilingualSyncDirective,
    DropdownToggleDirective
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    ToastrModule,
    HeaderComponent,
    SideNavComponent,
    LoaderComponent,
    TableComponent,
    FiltersComponent,
    MatSidenavModule,
    SelectModule,
    MultiSelectModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatMenuModule,
    ActionsMenuComponent,
    MatDialogModule,
    UploadFileComponent,
    MatStepperModule,
    MatProgressSpinnerModule,
    RiskDateIconComponent,
    RiskBagIconComponent,
    RiskScoreIconComponent,
    OpenTreatmentIconComponent,
    OverdueTreatmentIconComponent,
    PdfIconComponent,
    MatExpansionModule,
    DeleteModalComponent,
    TranslatePipe,
    AttachmentsComponent,
    ConfirmDialogComponent,
    AlertDialogComponent,
    FrequencySchedulingComponent,
    MatInputModule,
    MatSelectModule,
    TreeTableModule,
    SafeHtmlPipe,
    LocalizedDatePipe,
    DragDropModule,
    TreeModule,
    AuditingComponent,
    CarouselModule,
    CustomSelectComponent,
    ListComponent,
    DateRangePickerComponent,
    DatePickerComponent,
    TableModule,
    PaginationComponent,
    NoResultFoundComponent,
    BreadcrumbModule,
    TooltipModule,
    NoResultFoundComponent,
    MobileSidenavComponent,
    BreadCrumb,
    DocumentViewDetails,
    AutoCompleteModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    StagesHistory,
    MatBadgeModule,
    ShowHideColumnDialogComponent,
    EditorModule,
    BilingualSyncDirective,
    DropdownToggleDirective,
    HtmlToTextPipe
  ],
  providers: [ToastrService, TreeDragDropService]
})
export class SharedModule {}
